// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import { type JobRead, JobReadFromJSON, JobReadToJSON } from "../models/JobRead";
import { type JobStatus, JobStatusFromJSON, JobStatusToJSON } from "../models/JobStatus";
import { type PageJobRead, PageJobReadFromJSON, PageJobReadToJSON } from "../models/PageJobRead";
import { type PageLog, PageLogFromJSON, PageLogToJSON } from "../models/PageLog";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface JobListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Project ID
   */
  projectId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: JobListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Workflow ID
   */
  workflowId?: string | null;
  /**
   * Created by
   */
  createdBy?: string | null;
  /**
   * Process ID
   */
  processId?: string | null;
  /**
   * Case-insensitive substring search on job name
   */
  search?: string | null;
  /**
   * Filter by job status
   */
  status?: JobStatus | null;
}

export interface JobLogsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
}

export interface JobResultsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
}

export interface JobRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
}

/**
 *
 */
export class JobsApi extends runtime.BaseAPI {
  /**
   * Creates request options for jobList without sending the request
   */
  async jobListRequestOpts(requestParameters: JobListRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobList().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling jobList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["projectId"] != null) {
      queryParameters["project_id"] = requestParameters["projectId"];
    }

    if (requestParameters["workflowId"] != null) {
      queryParameters["workflow_id"] = requestParameters["workflowId"];
    }

    if (requestParameters["createdBy"] != null) {
      queryParameters["created_by"] = requestParameters["createdBy"];
    }

    if (requestParameters["processId"] != null) {
      queryParameters["process_id"] = requestParameters["processId"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/jobs`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a filtered list of jobs in a project.
   * list jobs
   */
  async jobListRaw(
    requestParameters: JobListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageJobRead>> {
    const requestOptions = await this.jobListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageJobReadFromJSON(jsonValue));
  }

  /**
   * Return a filtered list of jobs in a project.
   * list jobs
   */
  async jobList(
    requestParameters: JobListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageJobRead> {
    const response = await this.jobListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobLogs without sending the request
   */
  async jobLogsRequestOpts(requestParameters: JobLogsRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobLogs().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobLogs().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/logs`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of job log entries.
   * Show job logs
   */
  async jobLogsRaw(
    requestParameters: JobLogsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageLog>> {
    const requestOptions = await this.jobLogsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageLogFromJSON(jsonValue));
  }

  /**
   * Return a list of job log entries.
   * Show job logs
   */
  async jobLogs(
    requestParameters: JobLogsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageLog> {
    const response = await this.jobLogsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobResults without sending the request
   */
  async jobResultsRequestOpts(requestParameters: JobResultsRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobResults().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobResults().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/results`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return results of a job.
   * show job results
   */
  async jobResultsRaw(
    requestParameters: JobResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
    const requestOptions = await this.jobResultsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Return results of a job.
   * show job results
   */
  async jobResults(
    requestParameters: JobResultsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any }> {
    const response = await this.jobResultsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobRetrieve without sending the request
   */
  async jobRetrieveRequestOpts(
    requestParameters: JobRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobRetrieve().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of a job.
   * show job
   */
  async jobRetrieveRaw(
    requestParameters: JobRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<JobRead>> {
    const requestOptions = await this.jobRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => JobReadFromJSON(jsonValue));
  }

  /**
   * Return detailed information of a job.
   * show job
   */
  async jobRetrieve(
    requestParameters: JobRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<JobRead> {
    const response = await this.jobRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const JobListOrderByEnum = {
  StartedAt: "started_at",
  StartedAt2: "-started_at",
} as const;
export type JobListOrderByEnum = (typeof JobListOrderByEnum)[keyof typeof JobListOrderByEnum];
